export const defaultRulerValue = () => {
    return {
      type: null,
      start: 0,
      end: 10,
      stepsize: 1,
      styles: { height: 50, width: 600, bg_color: "#f9c74f", border_color: "#000", font_color: "#000" },
      num_lines: 9,
      design: "H",
    };
}